import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@15.5.2_@babel+core@7.28.3_babel-plugin-react-compiler@19.1.0-rc.2_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-sora\",\"preload\":true}],\"variableName\":\"sora\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/opt/build/repo/src/components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/opt/build/repo/src/components/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/build/repo/src/components/theme-provider.tsx");
